import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { BsFilter } from 'react-icons/bs';
import { dispatch, useGlobalState } from '../../store/state';
import { Pagination, Radio, Select } from 'antd';
import { Config } from '../../Config';
import BaseLayoutComponent from '../../components/Layout/Admin/BaseLayoutComponent';
import TopSubHeaderComponent from '../../components/Admin/Common/TopSubHeaderComponent';
import { CampaignSelectLists } from '../../apis/Brand/Campaigns/CampaignSelectLists';
// import { GetInfluencers } from '../../apis/Brand/Discovery/GetInfluencers';
import EmptyInfluencerComponent from '../../components/Admin/Influencers/EmptyInfluencerComponent';
import InfluencerCardComponent from '../../components/Admin/Influencers/InfluencerCardComponent';
import { GetAllInfluencers } from '../../apis/Admin/Influencers/GetAllInfluencers';
import { useHistory, useLocation } from 'react-router-dom';
import queryString from 'query-string';
import { GetPendingInfluencers } from '../../apis/Admin/Influencers/GetPendingInfluencers';

const { Option } = Select;
export const AdminInfluencersPage = () => {
  const history = useHistory();
  const [user] = useGlobalState('user');
  // const [company] = useGlobalState("company");
  // const [create_camp_general] = useGlobalState("create_camp_general");
  const [baseConfig, setBaseConfig] = useState({
    mode: 'all',
    topics: [],
    locations: [],
    type: 'all',
    page: 1,
  });
  const [paramData, setParamData] = useState({
    name: '',
    location: '',
    platform: 'all',
    interests: '',
  });
  const [infList, setInfList]= useState({
    list: [],
  });

  const fetchInfluencers = (page, limit, status) =>{
    if (status === 'pending') {
      GetPendingInfluencers(user.accessToken, page, limit).then(({ status, response })=>{
        // console.log("sdf",response)
        if (status === 200) {
          setInfList({
            ...infList,
            list: response.influencers,
          });
        } else {
          setInfList({
            ...infList,
            list: [],
          });
          // console.log("Failed to fetch Influencers List",response)
        }
      });
    } else {
      GetAllInfluencers(user.accessToken, page, limit).then(({ status, response })=>{
        // console.log("sdf",response)
        if (status === 200) {
          setInfList({
            ...infList,
            list: response.influencers,
          });
        } else {
          console.log('Failed to fetch Influencers List', response);
        }
      });
    }
  };


  // note: getting default select box fields value
  const retriveBaiscFieldSettings = () =>{
    CampaignSelectLists(user.accessToken).then(({ status, response }) =>{
      if (status === 200) {
        // let _set1 = response.topics
        // console.log("set 1",_set1)
        setBaseConfig({
          ...baseConfig,
          topics: response.topics,
          locations: response.locations,
        });
      }
    });
  };


  useEffect(() => {
    // retriveBaiscFieldSettings()
    const { status } = queryString.parse(history.location.search);
    // console.log("status",status)
    const _status = status === 'pending' ? status : 'all';
    setBaseConfig({
      ...baseConfig,
      mode: _status,
    });
    fetchInfluencers(1, 12, _status);
  }, [paramData]);

  // useEffect(()=>{
  // },[])

  const onNameSearch = (value) =>{
    setParamData({
      ...paramData,
      name: value,
      location: '',
    });
  };
  const onFilterChange = (value, filter) =>{
    if (filter === 'location') {
      setParamData({
        ...paramData,
        location: value,
      });
    } else if (filter === 'platform') {
      setParamData({
        ...paramData,
        platform: value,
      });
    } else if (filter === 'interests') {
      setParamData({
        ...paramData,
        interests: value,
      });
    } else {}
  };

  // const onPagingChange = (page)=>{ // pager changing
  //     // getCampiagnList(baseConfig.type,page)
  //     fetchInfluencers(20,page)
  //     setBaseConfig({
  //         ...baseConfig,
  //         page:page
  //     })
  // }

  const changeMode = (e) =>{
    // console.log("change",e.target.value)
    history.push({
      pathname: '/admin/dashboard/influencers',
      search: `?status=${e.target.value}`,
    });
    setBaseConfig({
      ...baseConfig,
      mode: e.target.value,
    });

    fetchInfluencers(1, 12, e.target.value);
  };

  return (
    <BaseLayoutComponent>
      <TopSubHeaderComponent className="px-3 py-2 sticky">
        <div className="row align-items-center">
          <div className="col-md-3">
            <span className="mb-0"><strong>Discover Influencers</strong></span>

            {/* <Link></Link> */}
            {/* <Select
                            style={{width:180}}
                            className="common_select"
                            name="platform"
                            defaultValue={paramData.platform}
                            placeholder="Filter by platform"
                            onChange={(value) => onFilterChange(value,'platform')}
                        >
                            <Option value="youtube">Youtube</Option>
                            <Option value="instagram">Instagram</Option>
                            <Option value="twitter">Twitter</Option>
                        </Select> */}
          </div>
          <div className="col-md-9 text-right">
            <span className="pr-3">
              <Radio.Group value={baseConfig.mode}
                buttonStyle="solid"
                onChange={changeMode}>
                <Radio.Button value="all">All</Radio.Button>
                <Radio.Button value="pending">Pending</Radio.Button>
              </Radio.Group>
            </span>
            <span>
              <BsFilter/>
            </span>
            <span className="text-left pl-2">
              <Select
                style={{ width: 180 }}
                className="common_select"
                name="platform"
                defaultValue={paramData.platform}
                placeholder="Filter by platform"
                onChange={(value) => onFilterChange(value, 'platform')}
              >
                <Option value="all">All</Option>
                <Option value="youtube">Youtube</Option>
                <Option value="instagram">Instagram</Option>
                <Option value="twitter">Twitter</Option>
              </Select>
            </span>
            <span className="text-left pl-2">
              <Select
                style={{ width: 180 }}
                className="common_select"
                name="location"
                // defaultValue={paramData.location}
                onChange={(value) => onFilterChange(value, 'location')}
                placeholder="Filter by location"
              >
                <Option value="">All {Config.country}</Option>
                {
                  baseConfig.locations.map((location)=>{
                    if (location !== `All ${Config.country}`) {
                      return <Option key={location}
                        value={location}>{location}</Option>;
                    }
                  })
                }
              </Select>
            </span>
            <span className="text-left pl-2">
              <Select
                style={{ width: 180 }}
                className="common_select"
                name="interests"
                // defaultValue={paramData.interests}
                placeholder="Filter by interests"
                onChange={(value) => onFilterChange(value, 'interests')}
              >
                <Option value="">All</Option>
                {
                  baseConfig.topics.map((topic)=>(
                    <Option key={topic}
                      value={topic}>{topic}</Option>
                  ))
                }
                {/* <Option value="science">Science</Option> */}
              </Select>
            </span>
          </div>
        </div>
      </TopSubHeaderComponent>
      <div className="d-flex flex-wrap p-2">
        {infList.list && infList.list.length ?
          infList.list.map((influencer) =><InfluencerCardComponent
            key={influencer.id}
            {...influencer}
            youtube={influencer.youtube_account}
            twitter={influencer.twitter_account}
            instagram={influencer.instagram_account}
            // allowAddList
            allowProfileBtn
            platform={paramData.platform}/> ):
          <EmptyInfluencerComponent>No influencers found</EmptyInfluencerComponent>
        }
      </div>
      {/* {
                infList.list.length?
                (<Pagination
                    onChange={onPagingChange}
                    // defaultCurrent={1}
                    current={baseConfig.page}
                    total={infList.listCount}
                    defaultPageSize={infList.limit}
                />)
                : null
            } */}
    </BaseLayoutComponent>
  );
};
